import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseInMemoryCachedRepository } from '@lib/domain-common';
export var QUESTION_RELEASE_IN_MEMORY_CACHED = 'QUESTION_RELEASE_IN_MEMORY_CACHED';
export var QuestionReleaseInMemoryCached = /*#__PURE__*/function (_BaseInMemoryCachedRe) {
  _inherits(QuestionReleaseInMemoryCached, _BaseInMemoryCachedRe);

  var _super = _createSuper(QuestionReleaseInMemoryCached);

  function QuestionReleaseInMemoryCached() {
    _classCallCheck(this, QuestionReleaseInMemoryCached);

    return _super.apply(this, arguments);
  }

  return QuestionReleaseInMemoryCached;
}(BaseInMemoryCachedRepository);